import React from 'react';
import classNames from 'classnames';
const Icons = (props) => {
  return (
    <i
      className={classNames({
        'c-self-test--icon': true,
        'c-self-test--icon-ok': props.iconType,
        'c-self-test--icon-not-ok': !props.iconType,
      })}
    >
      <span className="show-for-sr">
        {props.iconType ? 'rätt svar' : 'fel eller ofullständigt svar'}
      </span>
    </i>
  );
};

export default Icons;
